import type { ArticleImageProps } from '@/app/components/ArticleCardsModule';
import type { ArticleCardDataProps } from '@/app/components/ArticleCardsModule/ArticleCard';

export const ARTICLE_CARDS: ArticleCardDataProps[] = [
  {
    heading: 'membership_recent_app_fuels_your_nutrition',
    articleSource: {
      date: 'membership_nov_25',
    },
    buttonProps: {
      ariaLabel: 'press_read_article',
      external: true,
      color: 'dark',
      href: 'https://ouraring.com/blog/nutrition-levels',
      rel: 'noopener noreferrer',
      siteName: 'Oura Blog',
      target: '_blank',
    },
  },
  {
    heading: 'membership_recent_app_stress',
    articleSource: {
      date: 'membership_nov_25',
    },
    buttonProps: {
      ariaLabel: 'press_read_article',
      external: true,
      color: 'dark',
      href: 'https://ouraring.com/blog/what-is-cumulative-stress',
      rel: 'noopener noreferrer',
      siteName: 'Oura Blog',
      target: '_blank',
    },
  },
  {
    heading: 'membership_recent_app_health_panels',
    articleSource: {
      date: 'membership_oct_25',
    },
    buttonProps: {
      ariaLabel: 'press_read_article',
      external: true,
      color: 'dark',
      href: 'https://ouraring.com/blog/health-panels',
      rel: 'noopener noreferrer',
      siteName: 'Oura Blog',
      target: '_blank',
    },
  },
];

export const ARTICLE_IMAGE: ArticleImageProps = {
  alt: 'ceramic_hero_alt',
  buttonProps: {
    external: true,
    href: 'https://ouraring.com/blog/oura-cycle-insights-update',
    label: 'read_more',
    rel: 'noopener noreferrer',
    siteName: 'Oura Blog',
    target: '_blank',
    variant: 'secondary-light',
  },
  heading: 'membership_recent_app_cycle_title',
  mobileSrc: 'Main Article.jpg',
  src: 'women/featured.jpg',
};
